import {CdxCropImgByFile as RawCdxCropImgByFile} from "../../components/CdxImg";
import {Box, css, DSIconPlus, Row} from "@cdx/ds";
import {TooltipForChild, cx} from "@cdx/common";
import dsStyles from "@cdx/ds/css/index.css";
import {dsButtonStyles} from "@cdx/ds/components/DSButton/DSButton.css";
import RawUploader, {useUpload} from "../../components/uploader";
import {api} from "../../lib/api";
import {useRoot} from "../../lib/mate/mate-utils";
import {hasPermissionToManageProject} from "../../lib/permissions";

const CdxCropImgByFile = RawCdxCropImgByFile as any;
const Uploader = RawUploader as any;

const labelClasses = cx(
  dsStyles.position.relative,
  dsStyles.align.center,
  dsStyles.width["100%"],
  dsStyles.height["100%"],
  dsStyles.justify.center,
  dsStyles.display.flex,
  dsButtonStyles.base,
  dsButtonStyles.variantStyles.tertiary,
  dsButtonStyles.sizes.md,
  dsButtonStyles.iconColors.secondary
);

type AddCoverImageProps = {project: any};
const AddCoverImage = ({project}: AddCoverImageProps) => {
  const root = useRoot();
  const mayUpdate = hasPermissionToManageProject({root, project});

  const handleUpload = (data: any) =>
    (api as any).mutate.projects.updateCover({
      id: project.id,
      coverFileData: data,
      userId: root.loggedInUser.id,
    });

  const {inputProps, dropAreaProps, ongoingUploads} = useUpload({
    id: `projectCover-${project.id}`,
    onUpload: handleUpload,
  });

  if (!mayUpdate) return null;

  return (
    <TooltipForChild tooltip="Add cover image">
      <label className={labelClasses}>
        <DSIconPlus />
        <input {...inputProps} className={dsStyles.display.none} />
        {ongoingUploads.length > 0 && (
          <Box absolute bottom="0" left="0" right="0">
            <Uploader.Uploads ongoingUploads={ongoingUploads} />
          </Box>
        )}
        <Uploader.DropArea {...dropAreaProps} label="Drop cover image here" />
      </label>
    </TooltipForChild>
  );
};

type ProjectHeaderProps = {project: any};
const ProjectHeader = ({project}: ProjectHeaderProps) => {
  return (
    <Row sp="12px" align="center">
      <CdxCropImgByFile
        file={project.coverFile}
        width={44}
        height={44}
        className={css({
          elevation: 100,
          rounded: 4,
          width: "44px",
          height: "44px",
          colorTheme: "gray750",
          bg: "foreground",
        })}
        fallback={() => <AddCoverImage project={project} />}
      />
      <Box color="primary" size={16} bold>
        {project.name}
      </Box>
    </Row>
  );
};

export default ProjectHeader;
